import Page from '../../page';
import ListAsyncManager from "../../../helpers/asyncListManager/AsyncListManager";
import { AsyncListManagerEvent } from "../../../helpers/asyncListManager/AsyncListManager";

export default class VideosList extends Page {
    constructor(...args) {
        super(...args);

        this._action = 'candiapro_video_posts_ajax';

        this._retrieveDOM();
        this._initTls();
    }

    _retrieveDOM() {
        super._retrieveDOM();

        this.dom.load_more = this.dom.page.querySelector('.js-load-more');
        this.dom.results = this.dom.page.querySelector('.js-posts-list');
        this.dom.newvideos = [];

        this._ALM = new ListAsyncManager(this._action, this.dom.load_more);
        this._locked = false;

        this._allReadyInit();
    }
    
    _allReadyInit() {
        this.dom.videos = this.dom.page.querySelectorAll('.js-video-card');
        for (let i = 0; i < this.dom.videos.length; i++) {
            this.dom.videos[i].classList.add('is-binded');
        }
    }

    bind() {
        super.bind();

        // Load More
        if(this.dom.load_more) {
            this.dom.load_more.addEventListener('click', (e) => {
                if( this._locked == false ) {
                    this._locked = true;
                    this._ALM.loadMore(e);
                }
            });
        }

        // Data receive
        this._ALM.on(AsyncListManagerEvent.UPDATED, (xhr) => {
            this._injectData(xhr);
        });
    }

    _injectData(xhr) {
        this._locked = false;

        // Check if there is result
        if(xhr.data.has_results == false) {
            this.hideLoadMore();
        } else {

            // Check if there is other data to load
            if(xhr.data.load_more == true)
                this.showLoadMore();
            else
                this.hideLoadMore();

            if(xhr.data.page == 1) {
                this.dom.results.innerHTML = xhr.data.posts_html;
            } else {
                this.dom.results.insertAdjacentHTML('beforeend', xhr.data.posts_html);
            }

            this.newItems = document.querySelectorAll('.to-animate');
            this._bindNewVideoCard();
            for(var i = 0, j = this.newItems.length; i < j; i++)
            {
                var delay = i * 110;
                this._animateResult(i, delay);
            }
        }
    }

    hideLoadMore() {
        if( this.dom.load_more )
            this.dom.load_more.classList.add('hidden');
    }

    showLoadMore() {
        if( this.dom.load_more )
            this.dom.load_more.classList.remove('hidden');
    }

    _animateResult(index, delay) {
        setTimeout(() => {
            // this.newItems[index].classList.remove('to-animate');
        }, delay);
    }

    // _parseNewComponents() {
    //     this.dom.newvideos = this.dom.page.querySelectorAll('.not-init');

    //     for (let i = 0; i < this.dom.newvideos.length; i++) {
    //         const compVideo = this.dom.newvideos[i];
    //         console.log(compVideo);
    //         console.log(this._map.components['videoCard']);
    //         new this._map.components['videoCard'].default(compVideo);
    //     }
    // }

    

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/videos/list/videos-list.js